import Vue from 'vue'
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'

Vue.component('slow-fade', createSimpleTransition('slow-fade'))
Vue.component(
  'scroll-from-bottom-slow',
  createSimpleTransition('scroll-from-bottom-slow')
)
Vue.component(
  'scroll-from-bottom-normal',
  createSimpleTransition('scroll-from-bottom-normal')
)
Vue.component(
  'scroll-from-left-normal',
  createSimpleTransition('scroll-from-left-normal')
)
Vue.component(
  'scroll-from-left-slow',
  createSimpleTransition('scroll-from-left-slow')
)
Vue.component(
  'scroll-from-right-normal',
  createSimpleTransition('scroll-from-right-normal')
)
Vue.component(
  'scroll-from-right-slow',
  createSimpleTransition('scroll-from-right-slow')
)
